var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-movable-area',{staticClass:"fixed-area",style:({backgroundColor: _vm.backgroundColor})},[_vm._t("default"),(_vm.show)?_c('v-uni-movable-view',{staticClass:"ball",attrs:{"animation":_vm.animate,"x":_vm.x,"y":_vm.y,"direction":"all"},on:{"change":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.onChange).apply(void 0, arguments)
},"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.backMiniProgram).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticStyle:{"width":"30px","height":"30px"}},[_vm._v("返回直播")])],1):_vm._e()],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }